


































































import Vue from 'vue'
import { Location, User, Company } from '@/models'
import { trackGaEvent } from '@/util/helper'

import LeadConnectorModal from './LeadConnectorModal.vue'
import LeadConnectorIcon from '@/assets/pmd/img/launchpad/icon-lead-connector.svg'
import LeadConnectorMobileModal from './LeadConnectorMobileModal.vue'
import UsersService from '@/services/UsersService'

export default Vue.extend({
  props: [
    'currentLocationId',
    'userid',
    'activePlan',
    'mobileLinkError',
    'shortenUrl',
    'isLeadConnectorConnected',
    'mobileAppChecking',
  ],
  components: {
    LeadConnectorModal,
    LeadConnectorIcon,
    LeadConnectorMobileModal,
  },
  data() {
    return {
      sending: false,
      shortenedUrl: '',
      showModal: false,
      location: {} as Location,
      user: {} as User,
      showPhoneNumberModal: false,
      phone: '',
      company: {} as Company,
    }
  },
  async mounted() {
    this.user = await User.getById(this.userid)
    this.company = await Company.getById(this.user.companyId)
    this.phone = this.user.phone
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
    this.$root.$on('close-modal', () => {
      this.showModal = false
      this.showPhoneNumberModal = false
      if (this.mobileLinkError) this.$root.$emit('hide-mobile-error')
    })
    this.$root.$on('send-link', (phoneNumber: string) => {
      this.savePhoneAndSendLink(phoneNumber)
    })
  },
  watch: {
    shortenUrl: function (url) {
      this.shortenedUrl = url
    },
  },
  methods: {
    async sendLink() {
      try {
        const body = {
          location_id: this.location.id,
          type: 'mobile_app_link',
          user_id: this.userid,
        }

        const response = await this.$http.post('/launchpad/reminder', body)
        if (response.status == 200) {
          const data = response.data
          this.shortenedUrl = data.sms?.shortened_url
          this.showModal = true
          trackGaEvent(
            'Launchpad',
            'Sent mobile app link',
            `Sent mobile app link for location: ${this.currentLocationId}`
          )
        }
      } catch (err) {
        console.log(err)
      }
      this.showPhoneNumberModal = false
    },
    async savePhoneAndSendLink(phoneNumber: string) {
      if (!this.sending) {
        this.sending = true
        try {
          this.user.phone = phoneNumber
          // await this.user.save()
          await UsersService.update(this.user.id, { phone: phoneNumber })
          await this.sendLink()
          this.phone = this.user.phone
        } catch (err) {
          console.log(err)
        }
        this.sending = false
      }
    },
  },
})
